export default function PageHeading({ title, children }) {
  return (
    <div className="block-pd-y block-pd-x page-heading">
      <p className="title-h2m">{title}</p>
      <div className="btns-toolbar min-gap">{children}</div>
    </div>
  );
}
